import { checkIfIsArray } from '@e-socna/utils';

import type {
  UniqueOrListMaybeEmptyFieldValue,
  UniqueOrListOfUsageMaybeEmptyFieldValue,
} from '../types/field-value.type';

export const checkIfIsUsage = (
  value: UniqueOrListMaybeEmptyFieldValue,
): value is UniqueOrListOfUsageMaybeEmptyFieldValue =>
  value === null ||
  (typeof value === 'object' && !checkIfIsArray(value)) ||
  (checkIfIsArray(value) && typeof value[0] === 'object');
